import switchFunc from 'lib/function/switchFunc'

const MILES_PER_KM = 0.621371

export type DistanceUnit = 'mi' | 'km'

export const getUnit = switchFunc<DistanceUnit, 'US' | 'UK'>({ US: 'mi', UK: 'mi' }, 'km')

export function kmToMiles(km: number) {
  return km * MILES_PER_KM
}
